import { baseAPI } from "@/util/api.type";
import { UploadFile } from "./upload.type";
import { CallAPI_Upload, UploadRequestParams } from "./api";

export async function UploadFileAPI(file: File | Blob, destination: string, size?: number[]): Promise<UploadFile> {
    try {
        const uploadParams: UploadRequestParams = {
            file: file,
            platform: "application",
            destination: destination,
            size: size
        };

        const response = await CallAPI_Upload(uploadParams);

        if (response.statusCode === 403) {
            throw new Error("error.upload.403");
        }

        if (response.statusCode === 403) {
            throw new Error("error.upload.403");
        }
        
        return response.result.file;
    } catch (error) {
        throw new Error("error.upload.403");
    }
}
